<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div>
    <app-survey-frame-list>
      <app-survey-frame-list-template
        *ngFor="let address of survey.building.addresses; let i = index"
        [index]="i"
        [id]="address.id"
        [noClick]="true"
      >
        <div class="templateHeader" header>
          <div class="header-part">
            <ng-container *ngIf="!inPortrait; else keysPortrait">
              <div class="vertical-flex">
                <span class="bold">
                  <span i18n="@@general.address">Address</span>
                  {{ i + 1 }}
                </span>
                <span>{{ address?.lomKey ?? "-" }}</span>
              </div>
            </ng-container>
            <ng-template #keysPortrait>
              <div class="vertical-flex portrait">
                <span
                  ><span class="bold">A{{ i + 1 }}</span> -
                  <span class="small">{{ address?.lomKey ?? "" }}</span></span
                >
              </div>
            </ng-template>
          </div>
          <div style="margin-left: 1rem" class="header-part">
            <span class="address"> {{ address.getFullAddress() }}</span>
          </div>
          <div class="header-part grow"></div>
          <div class="header-part">
            <div class="circle grey-color clickable" (click)="onAddressChecked(address)" *ngIf="canChangeMainAddress(address)">
                <mat-icon class="material-icons-outlined"> home </mat-icon>
            </div>
            <div class="circle" *ngIf="address.id === mainAddressId">
              <mat-icon class="material-icons-outlined"> home </mat-icon>
            </div>
          </div>
        </div>
      </app-survey-frame-list-template>
    </app-survey-frame-list>
    <div class="surveyor-name-wrap" *ngIf="onTablet">
      <mat-icon class="material-icons-outlined"> inventory </mat-icon>
      <span class="surveyor-name">{{ fullName }}</span>
    </div>
  </div>
</div>
